
















import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import * as auth from "../../_store/auth.module";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class GestioneReportVisite extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;

  private listaReport: any;

  constructor() {
    super();
    this.titleParams = {
      title: "Elenco Visite Monitoraggio",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Tutor Formativo",
          value: "tutorFormativo"
        },
        {
          text: "Tirocinante",
          value: "tirocinante"
        },
        {
          text: "Azienda",
          value: "denominazioneAzienda"
        },
        {
          text: "Data Visita",
          value: "dataVisita"
        },
        {
          text: "Attività",
          value: "attivita"
        },
        {
          text: "Dettagli Report",
          value: "dettagliReport"
        },
        {
          text: "Status Report",
          value: "statusReport"
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI REPORT VISITA",
        type: "reportVisita"
      },
      filterType: "listaReport",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ]
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
  }

  loadReportList(idAnnoScolastico: number) {
    //var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchReportVisiteAdmin(this["$store"], payload)
      .then(result => {
        this.dataTableParams.records = result;
        this.listaReport = result;
        bus.$emit("dataLoaded");
        // console.log(result)
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    var articolazioniList: ArticolazioneInfo[];
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            data
              .dispatchArticolazioni(this["$store"], instituteInfo.id)
              .then(response => {
                response.forEach(element => {
                  this.dataTableParams.listaArticolazioni.push(element);
                });
                this.loadReportList(idAnnoScolastico);
              });

            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

      bus.$on("filtroReport", (filters: any) => {
      const listaReport: any = this.listaReport;
      var tempList: any = [];
      this.dataTableParams.records = [];
      listaReport.forEach((attivita: any) => {
        if (filters.filtroTipoAttivita !== "Tutti") {
          if (filters.filtroTipoAttivita === "Tirocini Estivi") {
            if (attivita.attivita ==="Tirocini Estivi") {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Tirocini Formativi") {
            if (attivita.attivita === "Tirocini Formativi") {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Tirocini Re/Inserimento") {
            if (attivita.attivita === "Tirocini Inserimento/ Reinserimento") {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "FSL Estiva") {
            if (attivita.attivita === "FSL Estiva") {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Workshop") {
            if (attivita.attivita === "Workshop") {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Colloqui CV") {
            if (attivita.attivita === "Colloqui CV") {
              tempList.push(attivita);
            }
          }
        } else {
          tempList.push(attivita);
        }
      });
      this.dataTableParams.records = tempList;
    });

    bus.$on("changeAnnoScolastico", (payload: any) => {
      this.loadReportList(payload);
    });
  }
}
